import {formatCurrency, formatDateTime} from "../../common/Utils";
import React from "react";

export default function CartCafeGroupItems({item}) {

  return (
    <>
      {item?.inventoryItem?.cafeOptions?.length > 0 && <>
        {item?.inventoryItem?.cafeOptions?.sort((a, b) => a.sortOrder - b.sortOrder).map((opt, idx) => {
          return (
            <p key={idx} style={{
              fontSize: '0.85rem',
              lineHeight: '0.9rem'
            }}>
              <b>{opt.optionGroupName}</b>
              <span style={{
                display: 'block'
              }}>
                              {opt?.options?.sort((a, b) => a.sortOrder - b.sortOrder)
                                .filter(copt => !copt?.specialInstructions && !copt?.scheduleDate)
                                .map((copt, idx) => {
                                  return (
                                    <span key={idx}>
                                    <small>{idx === 0 ? '' : ', '}{copt.optionName}
                                      &nbsp;{copt.price > 0 ? <>(+{formatCurrency(copt.price)})</> : ''}</small>
                                    </span>
                                  )
                                })
                              }
                {opt?.options?.sort((a, b) => a.sortOrder - b.sortOrder)
                  .filter(copt => copt?.scheduleDate && copt.scheduledAt?.length > 0)
                  .map((copt, idx) => {
                    return (
                      <span key={idx} style={{
                        display: 'block'
                      }}><small><b>{copt.optionName}</b><br/>{formatDateTime(copt.scheduledAt)}</small>
                                    </span>
                    )
                  })
                }
                {opt?.options?.sort((a, b) => a.sortOrder - b.sortOrder)
                  .filter(copt => copt?.specialInstructions && copt.instructions?.length > 0)
                  .map((copt, idx) => {
                    return (
                      <span key={idx} style={{
                        display: 'block'
                      }}><small><b>{copt.optionName}</b><br/>{copt.instructions}</small>
                                    </span>
                    )
                  })
                }

                            </span>
            </p>
          )
        })
        }
      </>}
    </>
  )
}